import { render, staticRenderFns } from "./flex-direction.vue?vue&type=template&id=6b580454&"
import script from "./flex-direction.vue?vue&type=script&lang=js&"
export * from "./flex-direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports